// extracted by mini-css-extract-plugin
export default {"AdminContainer":"Admin_AdminContainer__XjJjt","Table":"Admin_Table__FMPmH"};